import { ClientSlicesStore } from './client-slices-store-model';

export const getClientSlicesStore = (state: any): ClientSlicesStore =>
  state.clientSlices as ClientSlicesStore;
